import $ from 'jquery';

$('.evidence__header').on('click', function(event) {
  event.preventDefault();
  const $this = $(this);
  const $current = $(this).closest('.evidence--active');

  if ($current.length) {
    $current.find('.evidence__main').slideUp(200, function() {
      $current.removeClass('evidence--active');
    });

    return;
  }

  $this.closest('.evidence').find('.evidence__main').slideDown(200, function() {
    $this.closest('.evidence').addClass('evidence--active');
  });
});

$('.header__mobile-nav').on('click', function() {
  $('.nav-mobile').addClass('nav-mobile--active');
});

$('.nav-mobile__header .hamburger').on('click', function() {
  $('.nav-mobile').removeClass('nav-mobile--active');
  // $('.nav-mobile').removeClass('nav-mobile--submenu');
});

$('.nav-mobile__item').on('click', function(event) {
  if ($(this).data('submenu') !== undefined) {
    event.preventDefault();
    $('.nav-mobile__submenu').eq(parseInt($(this).data('submenu'), 10)).addClass('nav-mobile__submenu--active');
    $('.nav-mobile__menu');
    $('.nav-mobile').addClass('nav-mobile--submenu');
    $('.nav-mobile__back').addClass('nav-mobile__back--active');
  }
});

$('.nav-mobile__back').on('click', function() {
  $('.nav-mobile__submenu--active').removeClass('nav-mobile__submenu--active');
  $('.nav-mobile__back--active').removeClass('nav-mobile__back--active');
  $('.nav-mobile').removeClass('nav-mobile--submenu');
});



// WEBPACK FOOTER //
// ./assets/js/theme.js